var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapMarkerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 14.2596C4 6.3954 10.5051 0 18.5 0C26.4949 0 33 6.3954 33 14.2596C33 24.1146 20.2237 35.1018 19.6799 35.5644C19.3392 35.8542 18.9205 36 18.5 36C18.0795 36 17.6608 35.8542 17.3201 35.5644C16.7763 35.1018 4 24.1146 4 14.2596ZM13 12.5C13 9.46714 15.4671 7 18.5 7C21.5329 7 24 9.46714 24 12.5C24 15.5329 21.5329 18 18.5 18C15.4671 18 13 15.5329 13 12.5Z",
    fill: "#00B483"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_917_19554",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 29,
    height: 36
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 14.2596C4 6.3954 10.5051 0 18.5 0C26.4949 0 33 6.3954 33 14.2596C33 24.1146 20.2237 35.1018 19.6799 35.5644C19.3392 35.8542 18.9205 36 18.5 36C18.0795 36 17.6608 35.8542 17.3201 35.5644C16.7763 35.1018 4 24.1146 4 14.2596ZM13 12.5C13 9.46714 15.4671 7 18.5 7C21.5329 7 24 9.46714 24 12.5C24 15.5329 21.5329 18 18.5 18C15.4671 18 13 15.5329 13 12.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_917_19554)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerIcon);
export default __webpack_public_path__ + "static/media/map-marker-icon.d7ee567122109d7618e65dddfeca6f41.svg";
export { ForwardRef as ReactComponent };